import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: '#e2bc89',
                secondary: '#e2bc89',
                violet:'#7c62dd'
            },
            light: {
                primary: '#e2bc89',
                secondary: '#e2bc89',
                violet:'#7c62dd'
            },
        },
    },
})
